import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { BACKEND_API_URL } from '../../core/services/CusHttp';


@Component({
  selector: 'app-job-detail-small',
  templateUrl: './job-detail-small.component.html',
  styleUrls: ['./job-detail-small.component.scss']
})
export class JobDetailSmallComponent implements OnInit {
  @Input() titleHeader = "职位推荐";//标题名称
  @Input() link: string; //更多链接地址
  @Input() jobList: Array<Object> = [];//获取岗位列表
  @Output() jobId: any = new EventEmitter();
  public imgUrl = BACKEND_API_URL;
  constructor(
    public _router: Router,
  ) { }

  ngOnInit() {
  }
  goJobPage(did: any) {
    window.scrollTo(0, 0);//页面回到顶部
    this._router.navigate(['/job/detail/', did]);
  }
  // //漏油跳转
  // routerUrl() {
  //   this._router.navigate([this.link]);
  // }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/job-detail-small/job-detail-small.component.ts